import React, { Component } from 'react';
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {getPredefinedTexts, getPropertyDefinitions} from "../../redux/actions";
import {Alert, Table} from "react-bootstrap";
import PredefinedTextTableRow from "./PredefinedTextTableRow";
import {IMPORTED_PREDEFINED_TEXTS, SAVED_PREDEFINED_TEXT} from "../../redux/action-types";
import PaginationBar from "../reusables/PaginationBar";
import ExcelTools from "../reusables/StaticExcelTools";
import PrivateCoreService from "../../services/PrivateCoreService";
import Toolbar from "../reusables/Toolbar";
import AddPredefinedText from "./AddPredefinedText";
import ValueRender from "../reusables/ValueRender";
import ValueResolver from "../reusables/ValueResolver";
import FieldGroup from "../FieldGroup";

class PredefinedTextOverview extends Component {
    constructor(props) {
        super(props);
        this.customerId = props.match.params.id;
        this.loadPage(this.currentPage());
        this.privateCoreService = new PrivateCoreService(props.dispatch);

        this.state = { cleanImport: false };

        if(!this.props.propertyDefinitions) {
            this.loadPropertyDefinitions();
        }
    }

    componentDidUpdate() {
        if(this.props.lastAction && (this.props.lastAction.type === SAVED_PREDEFINED_TEXT
            || this.props.lastAction.type === IMPORTED_PREDEFINED_TEXTS)) {
            this.loadPage(this.currentPage());
        }
    }

    currentPage() {
        if(typeof this.props.predefinedTexts !== "undefined" && typeof this.props.predefinedTexts[this.customerId] !== "undefined") {
            return this.props.predefinedTexts[this.customerId].pagination.page;
        } else {
            return 0;
        }
    }

    loadPage(number) {
        this.props.dispatch(getPredefinedTexts({id: this.customerId, page: number, limit: 10}))
    }

    loadPropertyDefinitions() {
        this.props.dispatch(getPropertyDefinitions({id: this.customerId}));
    }

    static columnsForExcel() {
        return ["triggerProperty", "triggerValue", "targetProperty", "targetValue", "name", "type"];
    }

    propertyDefinitionById(id) {
        if(this.props.propertyDefinitions && this.props.propertyDefinitions[this.customerId] &&
            this.props.propertyDefinitions[this.customerId].data) {
            return this.props.propertyDefinitions[this.customerId].data.filter(entry => entry.id === id)[0];
        }
        else {
            return {};
        }
    }

    fieldFromProperty(propertyDefinitionId, apiField) {
        let pd = this.propertyDefinitionById(propertyDefinitionId);
        if(pd && pd[apiField]) {
            return pd[apiField];
        }
        else {
            throw new Error("Cant convert '"+propertyDefinitionId+"' to a '"+apiField+"'.")
        }
    }

    propertyDefinitionFromExcelData(excelData, excelField, apiField) {
        if(this.props.propertyDefinitions && this.props.propertyDefinitions[this.customerId] &&
            this.props.propertyDefinitions[this.customerId].data) {
            let properties = this.props.propertyDefinitions[this.customerId].data;

            let found = properties.filter(function(property) {
                return property[apiField].trim() === excelData[excelField].trim()
            });

            if(found.length === 1) {
                return found[0];
            }
            else if(found.length > 1) {
                throw new Error("Can't convert "+excelField+" '"+excelData[excelField]+"' to a property:\nThe "+apiField+" occurs more than once.");
            }
            else {
                throw new Error("Can't convert "+excelField+" '"+excelData[excelField]+"' to a property:\nThe property key must match EXACTLY.");
            }
        }
        else {
            throw new Error("Can't convert "+excelField+" '"+excelData[excelField]+"' to a property ID: Got no properties.");
        }
    }

    excelExportDataSource(callback) {
        let jwt = this.props.privateCoreJwt[this.customerId];
        this.privateCoreService.getAllPredefinedTexts(this.props.customer, jwt, function(res){
            callback(res.data)
        })
    }

    excelExportConversion(text) {
        // Translate to human readable format
        let renderTriggerValue = new ValueRender({
            propertyDefinition: this.propertyDefinitionById(text['triggerProperty']),
            value: text['triggerValue'],
            renderAttribute: 'value'
        });

        let renderTargetValue = new ValueRender({
            propertyDefinition: this.propertyDefinitionById(text['targetProperty']),
            value: text['targetValue'],
            renderAttribute: 'value'
        });

        if(text['triggerProperty']) {   // The trigger property may be absent cause of unconditional predefined texts.
            text['triggerProperty'] = this.fieldFromProperty(text['triggerProperty'], "propertyKey");
            text['triggerValue'] = renderTriggerValue.render();
        }
        else {
            text['triggerProperty'] = null;
            text['triggerValue'] = null;
        }

        text['targetProperty'] = this.fieldFromProperty(text['targetProperty'], "propertyKey");

        text['targetValue'] = renderTargetValue.render();
        return text;
    }

    excelImportDataTarget(data) {
        let jwt = this.props.privateCoreJwt[this.customerId];
        this.setState({cleanImport: false});
        this.privateCoreService.importPredefinedTexts(this.props.customer, jwt, data, this.state.cleanImport)
    }

    excelImportConversion(text) {
        function requireField(field, reference, required) {
            if(required && (!text[field] || text[field] === "")) {
                throw new Error("The '"+field+"' is required. You're missing it at "+reference+" '"+text[reference]+"'.");
            }
            else if(!required && !text.hasOwnProperty(field)) {
                throw new Error("The '"+field+"' should be present (but is nullable). You're missing it at "+reference+" '"+text[reference]+"'.");
            }
        }

        requireField('name', 'triggerValue', true);
        requireField('type', 'triggerValue', true);
        requireField('triggerProperty', 'name', false);
        requireField('triggerValue', 'name', false);
        requireField('targetValue', 'name', true);
        requireField('targetProperty', 'name', true);

        // From here on: Translate to system readable properties

        if(text['triggerProperty']) {   // This has to do with unconditional predefined texts.
            text['triggerProperty'] = this.propertyDefinitionFromExcelData(text, "triggerProperty", "propertyKey").id;
        }
        else {
            text['triggerProperty'] = null;
        }

        text['targetProperty'] = this.propertyDefinitionFromExcelData(text, "targetProperty", "propertyKey").id;

        let triggerPD = this.propertyDefinitionById(text['triggerProperty']);
        let triggerValueResolver = new ValueResolver({
            propertyDefinition: triggerPD,
            value: text['triggerValue'],
            searchAttribute: 'value',
            resolveAttribute: 'id'
        });

        text['triggerValue'] = triggerValueResolver.render();

        let targetPD = this.propertyDefinitionById(text['targetProperty']);
        let targetValueResolver = new ValueResolver({
            propertyDefinition: targetPD,
            value: text['targetValue'],
            searchAttribute: 'value',
            resolveAttribute: 'id'
        });

        text['targetValue'] = targetValueResolver.render();

        return text;
    }

    cleanImportChanged(e) {
        this.setState({cleanImport: e.target.checked});
    }

    isUnconditionalSupported() {
        let meta = this.props.predefinedTexts[this.customerId].meta;
        if(meta && meta.supported) {
            return meta.supported.indexOf("unconditional") !== -1;
        }
        else {
            return false;
        }
    }

    render() {
        let paginationBar = this.props.predefinedTexts && this.props.predefinedTexts[this.customerId] ?
            <PaginationBar current={this.currentPage()} show={5} first={0} onChange={nr => this.loadPage(nr)}
                           last={this.props.predefinedTexts[this.customerId].pagination.pages}/> : null;

        return this.props.predefinedTexts && this.props.predefinedTexts[this.customerId] ?
            <div>
                <Toolbar>
                    <ExcelTools fileName="predefined-texts"
                                subject="predefined texts"
                                actionTypeImported={IMPORTED_PREDEFINED_TEXTS}
                                importDataTarget={data => this.excelImportDataTarget(data)}
                                importConversion={entry => this.excelImportConversion(entry)}
                                exportDataSource={cb => this.excelExportDataSource(cb)}
                                exportConversion={entry => this.excelExportConversion(entry)}
                                columns={PredefinedTextOverview.columnsForExcel()}>
                        <br/>
                        <FieldGroup
                            checked={this.state.cleanImport}
                            id="private_core_https_enabled"
                            type="checkbox"
                            onChange={e => this.cleanImportChanged(e)}
                            label="Clean import?"
                            placeholder="80"
                        />
                        {this.state.cleanImport && <Alert bsStyle="warning">
                            Old predefined texts will be removed if you do a clean import. <br/>
                            You may want to create an export first.
                        </Alert>}

                    </ExcelTools>
                    <AddPredefinedText customerId={this.customerId} allowUnconditional={this.isUnconditionalSupported()}/>
                </Toolbar>

                {paginationBar}

                <Table striped bordered condensed hover>
                    <thead>
                    <tr>
                        <th>Trigger</th>
                        <th className="pre">Trigger value</th>
                        <th>Target</th>
                        <th className="pre predefined-text-target-value">
                            Target value
                        </th>
                        <th>Name</th>
                        <th className="predefined-text-type" colSpan="100%">Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    { this.props.predefinedTexts[this.customerId].data.map(text =>
                        <PredefinedTextTableRow customerId={this.customerId} key={text.id} text={text} allowUnconditional={this.isUnconditionalSupported()}/>
                    )}
                    </tbody>
                </Table>

                {paginationBar}
            </div>
        : null;
    }
}

const mapStateToProps = state => {
    return { pendingCalls: state.pendingCalls, customer: state.currentCustomer,
        privateCoreJwt: state.privateCoreJwt,
        propertyDefinitions: state.propertyDefinitions,
        predefinedTexts: state.predefinedTexts, lastAction: state.lastAction };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PredefinedTextOverview));


// WEBPACK FOOTER //
// ./src/components/predefined-text/PredefinedTextOverview.js